import { USALandingOptions } from "./USALandingOptions";
import type { LandingPageConfigOptions } from "landing/objects/LandingPageConfig";

export const LandingPageTemplate14: LandingPageConfigOptions = {
  consentAge: 21,
  ...USALandingOptions,
};
